export default __webpack_public_path__ + "static/media/Forgehammer.b378945d.jpg";